import { SyncOutlined } from "@ant-design/icons";
import { Button, Table, TableColumnType } from "antd";
import { TableProps } from "antd/es/table";
import { FilterValue, GetRowKey } from "antd/es/table/interface";
import { ReactNode } from "react";
import { TABLE_PAGE_SIZE } from "../constants";
import ExportToCSVButton from "../ExportToCSVButton";

export type OnChange<T> = NonNullable<TableProps<T>["onChange"]>;
export type Filters<T> = Parameters<OnChange<T>>[1];
export type DataType = Record<string, any>;

interface Props<T> {
  endpoint?: string;
  filter?: string;
  columns: TableColumnType<T>[];
  rowKey: keyof T | GetRowKey<T>;
  dataSource: T[];
  isLoading: boolean;
  refetch: () => void;
  currentPage?: number;
  onChangePage?: (page: number) => void;
  onFilterChange?: (filters: Filters<T>) => void;
  totalItems: number;
  prefixNode?: ReactNode;
  suffixNode?: ReactNode;
}

export default function TransactionsGrid<T>({
  rowKey,
  columns,
  isLoading,
  dataSource,
  refetch,
  onChangePage,
  currentPage,
  totalItems,
  onFilterChange,
  prefixNode,
  suffixNode,
  filter,
  endpoint,
}: Props<T>) {
  const handleOnChange: OnChange<T> = (pagination) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    onChangePage?.(pagination.current || 1);
  };

  return (
    <div className="custom-table-container custom-pagination">
      <div className="flex justify-end mb-8 gap-16">
        {prefixNode}
        <div className="flex items-center gap-1">
          <Button
            type="default"
            className="bg-primary text-white"
            onClick={() => {
              refetch();
            }}
          >
            <SyncOutlined />
            Refresh
          </Button>
          <ExportToCSVButton filter={filter} endpoint={endpoint} />
          <Button
            onClick={() => {
              onFilterChange?.({});
            }}
            type="default"
            className="bg-primary text-white"
          >
            Reset All
          </Button>
          {suffixNode}
        </div>
      </div>

      <Table
        rowKey={rowKey}
        size="small"
        loading={isLoading}
        onChange={handleOnChange}
        showSorterTooltip={true}
        columns={columns}
        dataSource={dataSource}
        virtual={false}
        scroll={{
          x: true,
        }}
        pagination={{
          position: ["bottomCenter"],
          total: totalItems,
          pageSize: TABLE_PAGE_SIZE,
          current: currentPage,
          showSizeChanger: false,
          showQuickJumper: false,
          showPrevNextJumpers: false,
          className: "custom-pagination",
          size: "default",
          showTotal: (total) => {
            return <div className="p-4"> total : {total}</div>;
          },
        }}
      />
    </div>
  );
}
